import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENVIRONMENT, API, MAX_CALLOUT_RETRIES } from 'src/app/_constants/app.constants';
import { GetBoardingPassDetailsRequest, GetBoardingPassDetailsResponse, SendBoardingPassDetailsRequest } from 'src/app/_models/boardingPass.model';
import { AuthService } from '../auth/auth.service';
import { LoggerService } from '../../ui/logger/logger.service';
import { AppModule } from 'src/app/app.module';
import { ServiceModule } from 'src/app/_services/service.module';
import { catchError, of } from 'rxjs';

@Injectable({
  providedIn: ServiceModule
})

export class BoardingPassService {

  private _boardingPassDetails: any = null
  private _currentRequest: any = null

  constructor(
    private http: HttpClient,
    private logger: LoggerService,
    private authService: AuthService
  ) { }

  /**
   *
   * Getter for boardingpass details
   *
  */
  get boardingPassDetails(): any {
    return this._boardingPassDetails ? { ...this._boardingPassDetails } : null;
  }

  /**
   *
   * Parses the response and sets it to the service
   *
   * @param boardingPassDetails - missing interface for type
   *
   */
  setBoardingPassDetails(boardingPassDetails): void {
    this.logger.debug('BoardingPassService: setBoardingPassDetails()', boardingPassDetails);
    this._boardingPassDetails = boardingPassDetails;
    this._boardingPassDetails.segmentList = this.getSegmentList(boardingPassDetails);
  }

  /**
   *
   * Sets the _boardingPassDetails property to null
   *
   */
  clearBoardingPassDetails(): void {
    this.logger.debug('BoardingPassService: clearBoardingPassDetails()');
    this._boardingPassDetails = null;
  }

  /**
   *
   * Parses the response and sets it to the service
   *
   * @param pnr
   * @param lastName
   *
   */
  async getBoardingPassDetails(request: GetBoardingPassDetailsRequest, retryCount: number = 0): Promise<void> {
    this.logger.debug('BoardingPassService.getBoardingPassDetails', this);
    this._currentRequest = request
    let url = `${ENVIRONMENT.PROPERTIES.apiUrl}${API.BOARDING_PASS}`;
    let body = {
      action: 'GET_BOARDING_PASS',
      ...request
    }

    const boardingpassResponse: any = await new Promise((res: any, rej: any) => {
      this.http.post(encodeURI(url), body, {
        headers: new HttpHeaders({
          'Hostname': this.authService.getHostName(),
          'Xsrf': this.authService.token
        })
      }).pipe(
        catchError(err => {
          return of({ success: false })
        })
      ).subscribe((data: any) => {
        res(data)
      })
    })

    const response = {
      code: boardingpassResponse.code,
      success: boardingpassResponse.success,
      ...boardingpassResponse.data,
    }


    // await this.http.post(encodeURI(url), body, {
    //   headers: new HttpHeaders({
    //     'Hostname': this.authService.getHostName(),
    //     'Xsrf': this.authService.token
    //   })
    // }).toPromise();

    if (response["success"]) {
      this.setBoardingPassDetails(response);
    } else {
      if (retryCount == MAX_CALLOUT_RETRIES) throw response;
      if (response["code"] == 403) {
        try {
          await this.authService.refreshToken();
          await this.getBoardingPassDetails(request, ++retryCount);
        } catch (e) {
          throw e;
        }
      } else throw response;
    }
  }

  async sendBoardingPassDetails(request: SendBoardingPassDetailsRequest, retryCount: number = 0): Promise<void> {
    this.logger.debug('BoardingPassService.sendBoardingPassDetails', this);
    this._currentRequest = request
    let url = `${ENVIRONMENT.PROPERTIES.apiUrl}${API.BOARDING_PASS}`;
    let body = {
      action: 'SEND_BOARDING_PASS',
      ...request
    }

    const boardingpassResponse: any = await new Promise((res: any, rej: any) => {
      this.http.post(encodeURI(url), body, {
        headers: new HttpHeaders({
          'Hostname': this.authService.getHostName(),
          'Xsrf': this.authService.token,
          'eventCreationSystem': "AncillaryPaymentSystem",
          'eventID': request.eventID
        })
      }).subscribe((data: any) => {
        res(data)
      })
    })

    const response = {
      code: boardingpassResponse.code,
      success: boardingpassResponse.success,
      ...boardingpassResponse.data,
    }

    // await this.http.post(encodeURI(url), body, {
    //   headers: new HttpHeaders({
    //     'Hostname': this.authService.getHostName(),
    //     'Xsrf': this.authService.token
    //   })
    // }).toPromise();

    if (response["success"]) {
      this.logger.debug('BoardingPassService.sendBoardingPassDetails', response)
    } else {
      if (retryCount == MAX_CALLOUT_RETRIES) throw response;
      if (response["code"] == 403) {
        try {
          await this.authService.refreshToken();
          await this.sendBoardingPassDetails(request, ++retryCount);
        } catch (e) {
          throw e;
        }
      } else throw response;
    }
  }

  /*
  *  getSegmentList - get the segment list
  *
  *  @param data - response object data
  */
  getSegmentList(response) {
    let segmentList = [];
    if (response && response.segmentList) {
      response.segmentList.filter((v, i, a) => a.findIndex(t => (t.segmentNumber === v.segmentNumber)) === i).flatMap(segment => {
        if (segment && segment.passengerList) {
          segment.passengerList.map(passenger => {
            segment = { ...segment, passengerList: passenger };
            if (passenger.bpImages && passenger.bpImages.length) {
              segmentList.push(segment);
            }
          });
        }
      });
    }
    return segmentList;
  }

}
